import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
    _fbq: (...args: unknown[]) => void;
    __MP_PIXEL_INITIALIZED?: boolean;
  }
}
const PIXEL_ID = '691118070725783';
export function MetaPixel() {
  useEffect(() => {
    // Prevent double initialization (React StrictMode or re-mounts)
    if (window.__MP_PIXEL_INITIALIZED) return;
    window.__MP_PIXEL_INITIALIZED = true;
    // If fbq already exists (e.g. loaded by another script), just track PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    // Initialize fbq
    const fbq = function (...args: unknown[]) {
      if ((fbq as any).callMethod) {
        ;
        (fbq as any).callMethod.apply(fbq, args);
      } else {
        ;
        (fbq as any).queue.push(args);
      }
    } as any;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [] as unknown[][];
    window.fbq = fbq;
    if (!window._fbq) window._fbq = fbq;
    // Load the Facebook pixel script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(script, firstScript);
    // Init pixel and fire single PageView
    window.fbq('init', PIXEL_ID);
    window.fbq('track', 'PageView');
    // No noscript img — it causes duplicate PageView in SPA apps
  }, []);
  return null;
}
export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Código de Sanación del Árbol',
      content_type: 'product',
      value: 11.99,
      currency: 'USD'
    });
  }
}